import React from "react";
import { Link } from 'react-router-dom';

export default function WhyChooseUs() {
    return (
        <>
            <section>
                <div className="custom-width mx-auto">
                    <div className="position-relative pt-5 text-center" style={{ zIndex: 1 }}>
                        <h2
                            className="text-center mb-5 text-primary fs-1"
                            style={{ fontWeight: 400 }}
                            data-aos="fade-up"
                        >
                            Why Retailers Choose Meera
                        </h2>

                        <div className="benefits-grid">
                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="100">
                                <img src="/assets/images/Home/Design.png" alt="Design Icon" />
                                <p>200+ Designs</p>
                                <p>Monthly</p>
                            </div>

                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="150">
                                <img src="/assets/images/Home/Services.png" alt="Service Icon" />
                                <p>Best In Class</p>
                                <p>Services</p>
                            </div>

                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="200">
                                <img src="/assets/images/Home/Manufacturing.png" alt="Factory Icon" />
                                <p>End-to-End In-house</p>
                                <p>Manufacturing</p>
                            </div>

                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="250">
                                <img src="/assets/images/Home/jewellery-icon.png" alt="Output Icon" />
                                <p>5000+ pieces</p>
                                <p>Monthly output</p>
                            </div>

                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="300">
                                <img src="/assets/images/Home/Suppliers.png" alt="Partnership Icon" />
                                <p>Partners. Not</p>
                                <p>Suppliers</p>
                            </div>

                            <div className="benefit-item" data-aos="fade-up" data-aos-delay="350">
                                <img src="/assets/images/Home/manufactur-exp.png" alt="Experience Icon" />
                                <p>Manufacturer</p>
                                <p>Experience</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light py-5">
                <div className="custom-width mx-auto ">
                    <div className="row g-4">

                        <div
                            className="col-12 col-lg-4 col-md-6 px-1"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <Link to="/product-range" className="text-decoration-none">
                                <div className="position-relative text-white">
                                    <img
                                        src="/assets/images/Home/2.png"
                                        alt="Browse Catalogs"
                                        className="img-fluid w-100"
                                        style={{ height: "550px", objectFit: "fill", border: "2px solid #dcdcdc" }}
                                    />
                                </div>
                            </Link>
                        </div>

                        <div
                            className="col-12 col-lg-4 col-md-6 px-1"
                            data-aos="fade-up"
                            data-aos-delay="600"
                        >
                            <Link to="/catalogs" className="text-decoration-none">
                                <div className="position-relative text-white">
                                    <img
                                        src="/assets/images/Home/3.png"
                                        alt="Browse catelog"
                                        className="img-fluid w-100"
                                        style={{ height: "550px", objectFit: "fill", border: "2px solid #dcdcdc" }}
                                    />
                                </div>
                            </Link>
                        </div>

                        <div
                            className="col-12 col-lg-4 col-md-6 px-1"
                            data-aos="fade-up"
                            data-aos-delay="800"
                        >
                            <Link to="/bin-stock" className="text-decoration-none">
                                <div className="position-relative text-white">
                                    <img
                                        src="/assets/images/Home/4.png"
                                        alt="Bin Stock"
                                        className="img-fluid w-100"
                                        style={{ height: "550px", objectFit: "fill", border: "2px solid #dcdcdc" }}
                                    />
                                </div>
                            </Link>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}

